import {
    SkyNetTableConfig, SkyNetTableField,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    OrderSubType,
    ProductType,
} from 'app/enums/label.enums'

import {
    PoolingFields,
} from '../pooling.types'

export const deliveryAddInfoFields: SkyNetTableField<PoolingFields>[] = [
    {
        name: 'orderNumber',
        width: '100px',
        reduced: true,
    },
    {
        name: 'from',
        filterField: 'from',
        filterType: FilterType.Array,
        width: '80px',
        reduced: true,
    },
    {
        name: 'to',
        filterField: 'to',
        filterType: FilterType.Array,
        width: '80px',
        reduced: true,
    },
    {
        name: 'orderSubType',
        filterField: 'orderSubType',
        filterType: FilterType.Array,
        componentName: 'EnumValue',
        width: '150px',
        allowedValuesEnum: OrderSubType,
        reduced: true,
    },
    {
        name: 'forwarderImport',
        labelKey: 'Order.forwarderImport',
        width: '200px',
        sorting: false,
    },
    {
        name: 'forwarderExport',
        labelKey: 'Order.forwarderExport',
        width: '200px',
        sorting: false,
    },
    {
        name: 'originLocationLocationName',
        filterField: 'originLocationLocationName',
        filterType: FilterType.Array,
        width: '200px',
    },
    {
        name: 'firstStepDeliveryLocationLocationName',
        labelKey: 'OrderPoolingInternalTransportsView.firstStepDeliveryLocationLocationName',
        width: '200px',
        sorting: false,
    },
    {
        name: 'destinationLocationLocationName',
        filterField: 'destinationLocationLocationName',
        filterType: FilterType.Array,
        width: '250px',
    },
    {
        name: 'mainMeansOfTransport',
        componentName: 'TransportMode',
        headerProps: {
            children: 'Mode',
        },
        filterField: 'mainMeansOfTransport',
        filterType: FilterType.Array,
        width: '150px',
    },
    {
        name: 'requiredContainers',
        componentName: 'RequiredContainersList',
        allowedValuesEnum: ProductType,
        filterField: 'requiredContainersContainerModel',
        filterType: FilterType.Array,
        labelKey: 'OrderPoolingInternalTransportsView.requiredContainers',
        width: '200px',
        sorting: false,
    },
    {
        name: 'requestedDeliveryLastStep',
        componentName: 'PoolingRequestedDelivery',
        labelKey: 'OrderStep.requestedDelivery',
        sorting: false,
        width: '100px',
    },
]

export default (isOverdueFilter: boolean): SkyNetTableConfig<PoolingFields> => {
    return {
        name: 'Pooling.AddInfo',
        tabs: [{
            name: 'Delivery: Add Info',
            url: CommonRoutes.All,
            fields: deliveryAddInfoFields,
            filters: {
                isOverdue: isOverdueFilter,
            },
        }],
    }
}
